<template>
  <div data-wd="sidenav">
    <div
      :class="{ [$style.screen]: true, [$style.screenHidden]: !isOpen }"
      data-wd="screen"
      @click="close"
    />
    <div
      class="ui sidebar vertical menu visible"
      :class="{ [$style.elHidden]: !isOpen, [$style.el]: true }"
    >
      <div class="item">
        <router-link
          :to="{ name: 'home' }"
          :class="$style.logoAnchor"
          data-wd="logo"
          @click.native="close"
        >
          <img
            src="../assets/images/logo.png"
            :alt="$t('terms.readgraphyLogo')"
          />
        </router-link>
        <h1 :class="$style.title">
          {{ $t("terms.readgraphy") }}
        </h1>
      </div>

      <div v-if="isLoggedIn" class="item">
        <div v-if="isCustomer" :class="$style.badge">
          <span :class="$style.badgeTitle"
            >{{ $t("terms.paidPlan") }}
            <span v-if="isEarlybird">({{ $t("terms.earlybird") }})</span></span
          >
        </div>
        <div :class="$style.email" data-wd="email">
          {{ user.email }}
        </div>
        <div v-if="purchaserReceived && !isCustomer" :class="$style.upgrade">
          <router-link
            :to="{ name: 'plans' }"
            class="ui inverted green button mini"
            data-wd="plans"
            @click.native="closeWithLog"
          >
            {{ $t("terms.upgrade") | cap }}
          </router-link>
        </div>
      </div>

      <nav role="navigation">
        <ul v-if="isLoggedIn" :class="$style.firstList">
          <li>
            <router-link
              :to="{ name: 'library' }"
              class="item"
              data-wd="library"
              @click.native="close"
            >
              {{ $t("terms.myLibrary") | cap }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'notelists' }"
              class="item"
              @click.native="
                $fa.logEvent($fa.Event.CLICK_NOTELISTS);
                close();
              "
            >
              <span v-new-feature="{ id: 'notelists', target: 'parent' }">
                {{ $t("terms.notelists") | cap }}
              </span>
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'tagManager' }"
              class="item"
              data-wd="tagManager"
              @click.native="close"
            >
              {{ $tc("terms.tag", 2) | cap }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'charts' }"
              class="item"
              data-wd="charts"
              @click.native="
                $fa.logEvent($fa.Event.CLICK_CHARTS);
                close();
              "
            >
              {{ $t("terms.charts") | cap }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'settings' }"
              class="item"
              data-wd="settings"
              @click.native="close"
            >
              {{ $t("terms.setting") | cap }}
            </router-link>
          </li>
        </ul>
        <ul v-else :class="$style.firstList">
          <li>
            <router-link
              :to="{ name: 'signin' }"
              class="item"
              data-wd="signin"
              @click.native="close"
            >
              {{ $t("terms.login") | cap }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'signup' }"
              class="item"
              data-wd="signup"
              @click.native="close"
            >
              {{ $t("terms.signup") | cap }}
            </router-link>
          </li>
        </ul>
      </nav>

      <div class="ui divider" />

      <ul>
        <li>
          <router-link
            :to="{ name: 'plans' }"
            class="item"
            data-wd="plans"
            @click.native="close"
          >
            {{ $t("terms.planInfo") | cap }}
          </router-link>
        </li>
        <li>
          <a class="item" data-wd="feedback" @click="openFeedback">{{
            $t("terms.feedback") | cap
          }}</a>
        </li>
      </ul>

      <div class="ui divider" />

      <div :class="$style.version">
        <span class="item">v{{ version }}</span>
      </div>
    </div>

    <dialog-feedback
      v-if="shownDialog"
      @cancel="closeFeedback"
      @confirm="completeFeedback"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import DialogFeedback from '@/components/DialogFeedback.vue'

export default {
  name: 'RgSidenav',
  components: { DialogFeedback },
  data () {
    return {
      shownDialog: false
    }
  },
  methods: {
    ...mapActions(['close']),
    closeWithLog () {
      this.$fa.logEvent(this.$fa.Event.CLICK_UPGRADE_NOTICE, {
        from: 'sidenav'
      })
      this.close()
    },
    openFeedback () {
      this.close()
      this.shownDialog = true
    },
    closeFeedback () {
      this.shownDialog = false
    },
    completeFeedback () {
      this.shownDialog = false
    }
  },
  computed: {
    ...mapState({
      purchaserReceived: (state) => state.purchases.purchaserReceived
    }),
    ...mapGetters([
      'isLoggedIn',
      'isOpen',
      'user',
      'isEarlybird',
      'isCustomer'
    ]),
    version () {
      return process.env.appVersion
    }
  },
  i18n: {
    messages: {
      ko: {
        terms: {
          upgrade: '계정 업그레이드',
          myLibrary: '내 서재',
          setting: '설정',
          login: '로그인하기',
          signup: '가입하기',
          feedback: '피드백',
          charts: '독서량 차트',
          notelists: '메모 리스트'
        }
      },
      en: {
        terms: {
          upgrade: 'upgrade',
          myLibrary: 'my library',
          setting: 'settings',
          login: 'sign in',
          signup: 'sign up',
          feedback: 'feedback',
          charts: 'reading chart',
          notelists: 'note lists'
        }
      }
    }
  }
}
</script>

<style scoped>
ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

h1 {
  font-size: 1.4rem;
}
</style>

<style module>
@value screenHidden from '~@/stylesheets/modal.css';

.screen {
  composes: screen from "~@/stylesheets/modal.css";
  z-index: 102;
}

.logoAnchor {
  position: relative;
  margin: 0 auto;
  width: 90%;
  padding: 20px 0;
  display: block;
  color: rgba(0, 0, 0, 0.87);

  &:hover {
    color: inherit;
  }
}

.logoAnchor img {
  width: 100%;
}

.el:global(.ui.sidebar) {
  transition: transform 0.5s ease;
}

.elHidden:global(.ui.sidebar) {
  transform: translate3d(-101%, 0, 0);
}

.title {
  display: none;
}

.version {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  font-style: italic;
}

.email {
  composes: ellipsis from "~@/stylesheets/app.css";
  line-height: 1.4285em;
}

ul.firstList {
  margin-top: 1rem;
}

.upgrade {
  margin-top: 8px;
}

.badge {
  font-size: 0.75rem;
  vertical-align: middle;
  margin-bottom: 4px;
}

.badgeTitle {
  position: relative;
  display: inline-block;
  padding-left: 10px;

  &::before {
    line-height: 12px;
    vertical-align: middle;
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #2185d0;
    transform: translateY(-50%);
  }
}
</style>
